$(window).load( function () {
  var modal = $('#myModal');
  var close = $(".close");
  var imgFeatured = $('#img-featured');
  var imagelist = $('#carousel-items .image');
  var images = document.getElementById("carousel-items") ? document.getElementById("carousel-items").getElementsByClassName("image") : '';
  
  
  // -------------------------------------------------------------------------------- 
  
  var ScreenWidth = screen.width;
  var winLocHref = window.location.href;
  var winLocOrigin = window.location.origin;
  var winLocPathname = window.location.pathname;
  var winLocHash = window.location.hash;
  var winLocSearch = window.location.search;
  var hashQuantity = new Number(winLocHash.split(":")[1] || "1");
  var hashCart = "#addCart:";
  var productSlug = winLocPathname.split("/products/")[1];

  // -----------------------------------------------------------------------------
  // Show a pop-up window if the customer did not choose a variant of the product(default variant of product)
  // -----------------------------------------------------------------------------
  function modalDefaultProductVariant() {
    if (
      winLocPathname.indexOf("/products/") > -1 &&
      winLocHash.indexOf("#addCart:") > -1 &&
      !(winLocSearch.indexOf("?variant=") > -1) &&
      !(sessionStorage.getItem("show-modal-product-variants") == productSlug)
    ) {
      if ($(".dialog-product-variant").length > 0) {
        $(".backdrop").css("display", "block");
        $(".dialog-product-variant").css("display", "block");
        sessionStorage.setItem("show-modal-product-variants", productSlug);
      }
    }
  }

  // -----------------------------------------------------------------------------

  if (ScreenWidth >= 1024) {
    modalDefaultProductVariant();

    if (winLocHash.indexOf(hashCart) > -1) {
      $(".cart-popup").show();
      setTimeout(function () {
        $(".cart-popup").hide();
      }, 6000);
    }

    // If a customer clicked add-to-cart button 3 times - will show up a pop-up
    if (hashQuantity == 3) {
      setTimeout(function () {
        $(".backdrop").css("display", "block");
        $(".dialog-cart-window").slideDown(300).show();
      }, 1000);
    }

    $("#product_configure_form").on("submit", function () {
      if (winLocHash.indexOf(hashCart) === -1) {
        window.location.href = winLocHref + hashCart + hashQuantity;
      } else {
        hashQuantity++;
        // Chosen or not any product variant
        winLocSearch
          ? (window.location.href =
              winLocOrigin +
              winLocPathname +
              winLocSearch +
              hashCart +
              hashQuantity)
          : (window.location.href =
              winLocOrigin + winLocPathname + hashCart + hashQuantity);
      }

      setTimeout(function () {
        location.reload();
      }, 500);
      
    });
  } else {
    $("#product_configure_form").on("submit", function () {
      if (
        !(winLocSearch.indexOf("?variant=") > -1) &&
        $(".dialog-product-variant").length > 0 &&
        !(sessionStorage.getItem("show-modal-product-variants") == productSlug)
      ) {
        $(".backdrop").css("display", "block");
        $(".dialog-product-variant").slideDown(300).show();
        sessionStorage.setItem("show-modal-product-variants", productSlug);
      } 
      else {
        setTimeout(function () {
          window.location.href = "/cart";
        }, 500);
      } 
      
      $(".close-popup").on("click", function () {
        window.location.href = "/cart";
      });
    });                                  
  }
  
  $("#product-select").change(()=>{  
  window.location = $( "select option:selected").attr("data-url");
  });
// --------------------------------------------------------------------------------
  

  if (images) {
    for (i = 0; i < images.length; i++) {
      images[i].setAttribute("data-index", i + 1 );
    }
  }

  if (images) {
    imgFeatured.empty();
    imgFeatured.append(images[0].cloneNode());
  }

  $('.image').mouseover(function() {
    imgFeatured.empty();
    imgFeatured.append($(this).clone());
  });

  $('#img-featured').click(function() {
    var slideIndex = Number($(this).children().attr("data-index"));

    $('#image-list').append(imagelist.clone());
    $('#image-preview').append(imagelist.clone());

    modal.css("display", "block");

    $('.image-list > .image').mouseover(function() {
      showSlides(slideIndex = Number($(this).attr("data-index")));
    });


    showSlides(slideIndex);


    $(".next").click(function () {
      console.log(slideIndex);
      showSlides(slideIndex += 1);
    });

    $(".prev").click(function () {
      showSlides(slideIndex += -1);
    });

    function showSlides(n) {
      var i;
      var slides = document.getElementById("image-preview").getElementsByClassName("image");
      var dots = document.getElementById("image-list").getElementsByClassName("image");

      if (n > slides.length) {slideIndex = 1}

      if (n < 1) {slideIndex = slides.length}

      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" modal-active", "");
      }

      dots[slideIndex-1].className += " modal-active";
      slides[slideIndex-1].style.display = "block";
    }
    console.log(modal.is(":visible"));
  });

  window.onclick = function(event) {
    if (modal.is(":visible") && modal.is(event.target))
    {
      modal.css("display", "none");
      $('.image-list').empty();
      $('.image-preview').empty();
    }
  };

  close.click(function() {
    modal.css("display", "none");
    $('.image-list').empty();
    $('.image-preview').empty();
  });

})


$(window).load(function(){  

  getMenu(); 

});  


function getMenu() {

  $.get( "https://apines.hktemas.com/api/shopify-category-menu", 

        { domain : 'https://de-grandado-com.myshopify.com' } 

       )

  .done(function( data ) {
    $("#jnix-menu").html(data.full);
    $("#full-menu").html(data.full);
    $("#site-menu ul.default-menu").append(data.mobile);
    //$(".dropdown-menu").html(data.full);
    $(".visit-category").text("Kategorie besuchen");


    /* MENU*/
    //   category*/

    var firstImemInMenu = $('.navigation-menu li').first(); 
    $('.category-container').hide();

    $('.menu-category-item').mouseover(function() {
      $(this).find("i").removeClass("down-arrow");
      $(this).find("i").addClass("up-arrow");
      $(".category-container").show();   
      $(".category-menu-items").show();
      $(".sub-catecories").empty();
      $('.grey-background').show();
      firstImemInMenu.find(".sub-container").clone().prependTo($(".sub-catecories"));
      firstImemInMenu.addClass('active').append("<div class='arrow-up'></div>"); 
      $(".sub-catecories .sub-container").show(); 
      $('body').css('overflow','hidden');
      $('.sub-container.drop-menu-sub-category').css({'overflow-y':'auto', 'overflow-x': 'hidden', 'max-height': '60vh'});
    });


    $('.navigation-menu li').click(function() {
      $('.navigation-menu li').removeClass('active');
      $( '.arrow-up' ).remove();
      $(this).addClass('active').append("<div class='arrow-up'></div>");

      $(".sub-catecories").empty();
      $(this).find( ".sub-container" ).clone().prependTo($(".sub-catecories"));
      $(".sub-catecories").show();
      $(".sub-catecories .sub-container").show();

    });

    $('.category-container').mouseover(function() {
      $(".category-container").show();   
      $(".category-menu-items").show();
      $('.grey-background').show();
      $(".sub-catecories .sub-container").show();
    });

    $('#btn-category').mouseleave(function() { 
      $(".category-container").hide();   
      $(".category-menu-items").hide();
      $( '.arrow-up' ).remove();
      $('.grey-background').hide();
      $('.menu-category-item').find("i").removeClass("up-arrow");
      $('.menu-category-item').find("i").addClass("down-arrow");
      $('body').css('overflow','auto');
    });

    /*daydeal */
    $('.daydeal').mouseover( function() {
      $('.daydeal i').removeClass("down-arrow");
      $('.daydeal i').addClass("up-arrow");
      $('.daydeal-menu').show();
    });
    $('.daydeal-show').mouseleave(function() {
      $('.daydeal i').removeClass("up-arrow");
      $('.daydeal i').addClass("down-arrow");
      $('.daydeal-menu').hide();
    });
    /*end daydeal */

    $('.cadeaus-inspiratie').mouseover( function() {
      $('.cadeaus-inspiratie i').removeClass("down-arrow");
      $('.grey-background').show();
      $('.cadeaus-inspiratie i').addClass("up-arrow");
      $('.cadeaus-inspiratie-menu').show();
    });
    $('.cadeaus-inspiratie-show').mouseleave(function() {
      $('.cadeaus-inspiratie i').removeClass("up-arrow");
      $('.grey-background').hide();
      $('.cadeaus-inspiratie i').addClass("down-arrow");
      $('.cadeaus-inspiratie-menu').hide();
    });

    /* END MENU */

    // script for hightlighting active menu item

    var currentHref = window.location.href.split('/').slice(3).join('/');		// path
    var tagA = $("#site-menu a[href$='" + currentHref + "']");                             // current menu item
    tagA.css({
      "font-size": "16px", 
      "font-weight": "bold"
    });
    tagA.parents('ul').css("display", "block");


    // end script for hightlighting active menu item

  })
  .fail(function() {
    console.log( "error" );
  })
}

$(window).load(function() {

  if($('#recently-viewed-products').is(':empty')){
    $('.itemonderp').hide();
  }

  var urlsort = window.location.search;
  var popularSort = '?sort_by=best-selling/?top10';
  var countProducts =  $('.showtop10').length;
  if(urlsort === popularSort){
    $('.showtop10').slice(10, countProducts).hide();
  }


  //   $('.opensub2').on('click', function(e){
  //     $(this).parent().find('ul.offcanvassubmenu2').slideToggle();
  //     e.preventDefault();
  //   });

  $('.sort-show').click(function() {
    $( ".sort-container" ).toggle(function() {
      console.log('dd');
    });
  }); 
  $('.filter-show').click(function() {
    $( ".filters" ).toggle();
  }); 

  //-------------------------------------------------------
  // cart pop-up
  //
  $(".show-cart-popup").click(function(){
    $(".cart-popup").toggle();
  });

  //   $(".cart-popup").mouseleave(function(){
  //     $(".cart-popup").hide();
  //   });

  $(document).click(function (e) {
    if (!$(e.target).parents().andSelf().is('.show-cart-popup')) {
      $(".cart-popup").hide();
    }
  });

  $(".cart-popup").click(function (e) {
    e.stopPropagation();
  });
  //-------------------------------------------------------
  
  var urlPath = window.location.pathname;
  var siteMap = "/apps/sitemap";
  if (urlPath === siteMap) {
    console.log("sitemap app");
    $("#content").addClass("container");
  }
  
  //Footer flag dropDown ---------------------
  $("#footer-flag-btn").hover(function(){
    $("#footer-flags").show();
  });
  $("#footer-flags").mouseleave(function(){
    $("#footer-flags").hide();
  });

  //mobile
  $("#footer-flag-mobile-btn").click(function(){
    $("#footer-flags-mobile").toggle();
  });

  //Footer flag dropDown ---------------------

  $('.product-info-container img').prependTo($(".product-images"));

  if($('.product-images').is(':empty')){
    $(".img-block-shows").hide();
    $(".product-images").hide();
  }

  var heighttabfull = $(".tab-content")[0] ? $(".tab-content")[0].scrollHeight :null;
  var heightnotfull = $(".tab-content").height();

  $(".hide-inform").click(function(){
    $(".show-inform").show();
    $(".hide-inform").hide();
    $(".tab-content").height(496);


  });

  $(".show-inform").click(function(){
    $(".show-inform").hide();
    $(".hide-inform").show();
    $(".tab-content").height(
      $(".tab-pane.active").height())
  }); 

  //   Remove empty div

  $('.tab-pane').find('br').remove();


  var emptyP = $('.tab-pane p');
  var emptyH2 = $('.tab-pane h2');

  emptyP.each(function() {
    if ($( this ).text().trim().length === 0) {
      $(this).remove();
    }
  });

  emptyH2.each(function() {
    if ($( this ).text().trim().length === 0) {
      $(this).remove();
    }
  });

  //-----------------------------------

  if($(".tab-pane.active").height() < 496) {
    $("#show-more-btn").css("cssText", "display: none !important");
  } 

  $("#info-btn, #verzending-btn").click(function(){
    $(".tab-content").height(496);
    $(".show-inform").show();
    $(".hide-inform").hide();
    setTimeout(function() {
      if($(".tab-pane.active").height() < 496) {
        $("#show-more-btn").css("cssText", "display: none !important");
      }  else {
        $("#show-more-btn").css("cssText", "display: block !important; margin-top: 25px;");
      }
    }, 0);
  });


  var heighttabfullslider = $(".many-sliders")[0] ? $(".many-sliders")[0].scrollHeight : null; 
  var heightnotfullslider = $(".many-sliders").height();
  $(".hide-slider").click(function(){
    $(".slider-show").show();
    $(".hide-slider").hide();
    $(".many-sliders").height(heightnotfullslider);

  });

  $(".slider-show").click(function(){
    $(".slider-show").hide();
    $(".hide-slider").show();
    $(".many-sliders").height(function(i,val){
      return heightnotfullslider + (heighttabfullslider - heightnotfullslider);
    });
  });


  var heighttabfullimg = $(".product-images")[0] ? $(".product-images")[0].scrollHeight: null;
  var heightnotfullimg = $(".product-images").height();
  $(".hide-images").click(function(){
    $(".show-images").show();
    $(".hide-images").hide();
    $(".product-images").height(heightnotfullimg);
  });

  $(".show-images").click(function(){
    $(".show-images").hide();
    $(".hide-images").show();
    $(".product-images").height(function(i,val){
      return heightnotfullimg + (heighttabfullimg - heightnotfullimg);
    });
  });

});

$(window).ready(function() {

  function cutLongString(element, count_lit){
    var text = element.html();
    var all_len = text ? text.length : null;
    var new_text;


    if (all_len > count_lit){
      new_text = text.substr(0, (count_lit - 3)) + '...';      
    }
    element.html(new_text);
  }


  $(".expandablepp h2").first().css( "font-size", "22px" );

  var first_p = $(".expandablepp p").first();
  var first_div = $(".expandablepp div").first();
  var first_ol = $(".expandablepp ol").first();
  var second_p = $(".expandablepp p").eq(1);
  var n1 = first_p[0] ? first_p[0].textContent.length : null;
  var n2 = second_p[0] ? second_p[0].textContent.length : null;
  var n3 = first_div[0] ? first_div[0].textContent.length : null;

  if ( n1 > 10 ) {
    first_p.css( "font-size", "19px" );
    cutLongString($(first_p.clone().prependTo('.copy-text')), 230);
    $('.copy-text p').append(function(indx, val){ 
      return '<a class="gototab"  style="color: #226cb0; cursor: pointer;">Lees meer</a>'; });
  } else if (n2 > 10) {
    second_p.css( "font-size", "19px" );

    cutLongString($(second_p.clone().prependTo('.copy-text')), 230);
    $('.copy-text p').append(function(indx, val){ 
      return '<a class="gototab"  style="color: #226cb0; cursor: pointer;">Lees meer</a>'; });
  } else if (n3 > 10 ){
    first_div.css( "font-size", "19px" );
    cutLongString($(first_div.clone().prependTo('.copy-text')), 230);
    $('.copy-text div').append(function(indx, val){ 
      return '<a class="gototab"  style="color: #226cb0; cursor: pointer;">Lees meer</a>'; });
  }else {
    first_ol.css( "font-size", "19px" );
    cutLongString($(first_ol.clone().prependTo('.copy-text')), 230);
    $('.copy-text ol').append(function(indx, val){ 
      return '<a class="gototab"  style="color: #226cb0; cursor: pointer;">Lees meer</a>'; });
  }




  var scrollTop = $('.product-info-container').offset() ? $('.product-info-container').offset().top - 100 : null;
  $('.gototab').click( function(){
    $(document).scrollTop(scrollTop);
  });


});
//lang
(function($, window, document, undefined) {

  'use strict';

  var $html = $('html');

  $html.on('click.ui.dropdown', '.js-dropdown', function(e) {
    e.preventDefault();
    $(this).toggleClass('is-open');
  });

  $html.on('click.ui.dropdown', '.js-dropdown [data-dropdown-value]', function(e) {
    e.preventDefault();
    var $item = $(this);
    var $dropdown = $item.parents('.js-dropdown');
    $dropdown.find('.js-dropdown__input').val($item.data('dropdown-value'));
    $dropdown.find('.js-dropdown__current').text($item.text());
  });

  $html.on('click.ui.dropdown', function(e) {
    var $target = $(e.target);
    if (!$target.parents().hasClass('js-dropdown')) {
      $('.js-dropdown').removeClass('is-open');
    }
  });

})(jQuery, window, document);

//lang end

//slider new2
$(document).on('click', ".new2carousel-button-right",function(){
  var new2carusel = $(this).parents('.new2carousel');
  new2right_carusel(new2carusel);
  return false;
});

$(document).on('click',".new2carousel-button-left",function(){
  var new2carusel = $(this).parents('.new2carousel');
  new2left_carusel(new2carusel);
  return false;
});
function new2left_carusel(carusel){
  var block_width = $(carusel).find('.new2carousel-block').outerHeight();
  console.log("Carusel", $(carusel).find(".new2carousel-items .new2carousel-block"));
  $(carusel).find(".new2carousel-items .new2carousel-block").eq(-1).clone().prependTo($(carusel).find(".new2carousel-items"));
  $(carusel).find(".new2carousel-items .new2carousel-block").eq(-2).clone().prependTo($(carusel).find(".new2carousel-items"));
  $(carusel).find(".new2carousel-items .new2carousel-block").eq(-3).clone().prependTo($(carusel).find(".new2carousel-items"));

  $(carusel).find(".new2carousel-items").css({"left":"-"+3*block_width+"px"});
  $(carusel).find(".new2carousel-items .new2carousel-block").slice(-3).remove();

  $(carusel).find(".new2carousel-items").animate({left: "0px"}, 500);

}
function new2right_carusel(carusel){
  var block_width = $(carusel).find('.new2carousel-block').outerHeight();

  $(carusel).find(".new2carousel-items").animate({left: "-" + 3 * block_width + "px"}, 500, function(){

    $(carusel).find(".new2carousel-items .new2carousel-block").eq(0).clone().appendTo($(carusel).find(".new2carousel-items"));
    $(carusel).find(".new2carousel-items .new2carousel-block").eq(1).clone().appendTo($(carusel).find(".new2carousel-items"));
    $(carusel).find(".new2carousel-items .new2carousel-block").eq(2).clone().appendTo($(carusel).find(".new2carousel-items"));
    $(carusel).find(".new2carousel-items .new2carousel-block").slice(0, 3).remove();
    $(carusel).find(".new2carousel-items").css({"left":"0px"});

  });
}

$(function() {

  //  auto_right('.carousel:first');
})


function auto_right(carusel){
  setInterval(function(){
    if (!$(carusel).is('.hover'))
      right_carusel(carusel);
  }, 1000)
}

$(document).on('mouseenter', '.newcarousel', function(){$(this).addClass('hover')})

$(document).on('mouseleave', '.newcarousel', function(){$(this).removeClass('hover')})


//end slider
//slider
$(document).on('click', ".newcarousel-button-right",function(){
  var newcarusel = $(this).parents('.newcarousel');
  newright_carusel(newcarusel);
  return false;
});

$(document).on('click',".newcarousel-button-left",function(){
  var newcarusel = $(this).parents('.newcarousel');
  newleft_carusel(newcarusel);
  return false;
});
function newleft_carusel(carusel){
  var block_width = $(carusel).find('.newcarousel-block').outerHeight();
  $(carusel).find(".newcarousel-items .newcarousel-block").eq(-1).clone().prependTo($(carusel).find(".newcarousel-items"));
  $(carusel).find(".newcarousel-items .newcarousel-block").eq(-2).clone().prependTo($(carusel).find(".newcarousel-items"));
  $(carusel).find(".newcarousel-items .newcarousel-block").eq(-3).clone().prependTo($(carusel).find(".newcarousel-items"));
  $(carusel).find(".newcarousel-items").css({"left":"-"+3*block_width +"px"});
  $(carusel).find(".new2carousel-items .new2carousel-block").slice(-3).remove(); 
  $(carusel).find(".newcarousel-items").animate({left: "0px"}, 500);


}
function newright_carusel(carusel){
  var block_width = $(carusel).find('.newcarousel-block').outerHeight();
  $(carusel).find(".newcarousel-items").animate({left: "-"+ 3*block_width+"px"}, 500, function(){
    $(carusel).find(".newcarousel-items .newcarousel-block").eq(0).clone().appendTo($(carusel).find(".newcarousel-items")); 
    $(carusel).find(".newcarousel-items .newcarousel-block").eq(1).clone().appendTo($(carusel).find(".newcarousel-items")); 
    $(carusel).find(".newcarousel-items .newcarousel-block").eq(2).clone().appendTo($(carusel).find(".newcarousel-items")); 
    $(carusel).find(".newcarousel-items .newcarousel-block").slice(0, 3).remove();

    $(carusel).find(".newcarousel-items").css({"left":"0px"});
  });
  console.log( $(carusel).find(".newcarousel-items .newcarousel-block").eq(1));
  console.log( $(carusel).find(".newcarousel-items .newcarousel-block").eq(2));
}


$(function() {

  //  auto_right('.carousel:first');
})


function auto_right(carusel){
  setInterval(function(){
    if (!$(carusel).is('.hover'))
      right_carusel(carusel);
  }, 1000)
}

$(document).on('mouseenter', '.newcarousel', function(){$(this).addClass('hover')})

$(document).on('mouseleave', '.newcarousel', function(){$(this).removeClass('hover')})

$(document).ready(function() {

  $('.closediv').click(function() {
    $('#makeachoice').css('display','none');
  });
});

// ---------------------------------------------------------------------------------------------------------------------
$(document).ready(function() {
  // Clock counter to the end of the day ------------------------------------------
//   (function($) {
//     var date = new Date(),
//         month = date.getMonth(),
//         day = date.getDate(),
//         weekDay = date.getDay(),
//         hours = {
//           start: new Date(date.getFullYear(), month, day),
//           end: new Date(date.getFullYear(), month, day)
//         };

//     hours.start.setHours(0); // Start at 0am, end at 12pm
//     hours.end.setHours(23); // +1 because its index

//     function countDown() {
//       var date = new Date(),
//           countHours = ("0" + (hours.end.getHours() - date.getHours())).substr(
//             -2
//           ),
//           countMinutes = ("0" + (59 - date.getMinutes())).substr(-2),
//           countSeconds = ("0" + (59 - date.getSeconds())).substr(-2);

//       $(".clock-prod-block #hours").text(countHours);
//       $(".clock-prod-block #minutes").text(countMinutes);
//       $(".clock-prod-block #seconds").html(countSeconds);
//     }

//     $(function() {
//       setInterval(function() {
//         countDown();
//       }, 1000);
//     });
//   })(jQuery);
  // -------------------------------------------------------------------------------

  // Quick-links ----------------------------------------------------------------
  $(".quick-links .clickable-bl").on("click", function(e) {
    e.preventDefault();
    $(".backdrop").css("display", "block");
    $(this)
    .next()
    .slideDown(300)
    .show();
  });

  // ----------------------------------------------------------------------------
  $("#quantity").on("change", function(e) {
    e.preventDefault();
    var selectedOption = $("#quantity option:selected");
    if (selectedOption.hasClass("changeable-option")) {
      $(".quantity-popup").css("display", "flex");
    }
  });
  // -----------------------------------------------------------------------------

  // Close BTN, backdrop clicked -------------------------------------------------
  $(".backdrop, .close-btn, .close-popup").on("click", function(e) {
    e.preventDefault();
    $(".backdrop").css("display", "none");
    $(".popup-window").css("display", "none");
  });
  // -----------------------------------------------------------------------------
  $("#submitNewQuantity").on("click", function(e) {
    e.preventDefault();
    var newQuantityVal = $("#newQuantity")[0].value;

    $("#quantity option:last-child")
    .val(newQuantityVal)
    .text("mehr(" + newQuantityVal + ")");

    $(".popup-window").css("display", "none");
  });

  // change input search //placeholder value after searching -----------
  if (window.location.href.indexOf("/search?q=") > -1) {
    var searchInput = $(".main-search-form input");
    var searchValue = window.location.search.split("=")[1];
    console.warn("search value:", searchValue);
    var searchItem =
        searchValue !== "" ? searchValue : searchInput.attr("placeholder");
    // searchInput.attr("placeholder", searchItem);
    searchInput.val(searchItem.split("+").join(" "));
  }
  //------------------------------------------------------------
});
// -------------------------------------------------------------------------------

var hover_timer;
var hover_delay = 400;
$(document).ready(function() {

  var col_5_container = $('#jnix-menu ul.navigation li .typography_5_col .col_5_container');

  $.each(col_5_container, function() {
    $(this).css('min-height', $('#vt_menu ul.navigation').height() - 50);
    $(this).css('height', 'auto');
  });
}).on('mouseenter', '#vt_menu ul.navigation > li', function() {
  var menu = $(this), container = menu.parent();

  if (!container.hasClass('active-menu')) {
    hover_timer = setTimeout(function() {
      menu.addClass('active-menu-item');
      container.addClass('active-menu');
    }, hover_delay);
  } else {
    menu.siblings().removeClass('active-menu-item');
    menu.addClass('active-menu-item');
  }
}).on('mouseleave', '#vt_menu ul.navigation, .typography_5_col', function() {
  clearTimeout(hover_timer);
  setTimeout(function() {
    if ($('#vt_menu ul.navigation:hover').length == 0 && $('.typography_5_col:hover').length == 0) {


      $('#vt_menu ul.navigation > li').removeClass('active-menu-item');
      $('#vt_menu ul.navigation').removeClass('active-menu');
    }
  }, 400);


});

